import React from 'react';
import { style, $ } from 'glamor';

import UserPlaceholder from './UserPlaceholder';

const renderImage = function(src) {
  if (src) {
    return <div {...style({
      maxHeight: '100vh',
      width: '100%',
      height: '100%',
    })}>
      <img {...style({
        width: '100%',
        height: '100%',
      })} src={src} />
    </div>;
  } else {
    return <div {...style({
      maxHeight: '100vh',
      width: '100%',
      height: '100%',
    })}>
      <div
        {...style({flexShrink: '0'})}
        {...$('path', {fill: '#BECED2'})}
        dangerouslySetInnerHTML={{__html: UserPlaceholder()}}
      />
    </div>;
  }
};

type Props = {
  src: String,
  onClick: () => void,
};

export default function ProductImage({ src, onClick }: Props) {
  return <div {...style({
    maxWidth: '100%',
    overflow: 'hidden',
  })} onClick={onClick}>
    {renderImage(src)}
  </div>;
}



// WEBPACK FOOTER //
// ../src/client/components/images/ProductImage.js